import { coerceBooleanProperty } from '@angular/cdk/coercion';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, ContentChildren, Directive, EventEmitter, Output, ContentChild, NgModule } from '@angular/core';
import * as i2$1 from '@angular/router';
import { NavigationEnd, RouterModule } from '@angular/router';
import { BehaviorSubject, Subject, combineLatest } from 'rxjs';
import { debounceTime, takeUntil, filter } from 'rxjs/operators';
import * as i3 from '@xpo-ltl/ngx-ltl-core/header';
import { XpoHeaderAppName, XpoHeaderSubAppName, XpoHeaderModule } from '@xpo-ltl/ngx-ltl-core/header';
import * as i1$1 from '@angular/cdk/layout';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from '@xpo-ltl/ngx-ltl-core/tab-drawer';
import { XpoTabDrawerModule } from '@xpo-ltl/ngx-ltl-core/tab-drawer';
import * as i2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { XpoAccountPopoverModule } from '@xpo-ltl/ngx-ltl-core/account-popover';
import { XpoAppSwitcherPopoverModule } from '@xpo-ltl/ngx-ltl-core/app-switcher-popover';
import { XpoNotificationPopoverModule } from '@xpo-ltl/ngx-ltl-core/notification-popover';

const _c0$3 = ["xpo-shell-navigation", ""];
const _c1$2 = ["*"];
class XpoShellNavigation {
}
XpoShellNavigation.ɵfac = function XpoShellNavigation_Factory(t) { return new (t || XpoShellNavigation)(); };
XpoShellNavigation.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoShellNavigation, selectors: [["", "xpo-shell-navigation", ""]], hostAttrs: [1, "xpo-ShellNavigation"], attrs: _c0$3, ngContentSelectors: _c1$2, decls: 1, vars: 0, template: function XpoShellNavigation_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵprojection(0);
    } }, styles: [".flex--stretch{flex:1}.xpo-ShellNavigationGroup{display:block;position:relative;border-bottom:1px solid transparent;border-top:1px solid transparent}.xpo-ShellNavigationGroup .xpo-ShellNavigationItem--is-active+.xpo-ShellNavigationItem-children{background:#fcfcfc}.xpo-ShellNavigationGroup .xpo-ShellNavigationItem--is-active+.xpo-ShellNavigationItem-children .xpo-ShellNavigationItem:before{background-color:#0d94f4;content:\"\";display:block;height:32px;position:absolute;width:4px}.xpo-ShellNavigationGroup .xpo-ShellNavigationItem--is-child{height:32px;border-bottom:1px solid transparent;border-top:1px solid transparent}.xpo-ShellNavigationGroup .xpo-ShellNavigationItem--is-child:hover,.xpo-ShellNavigationGroup .xpo-ShellNavigationItem--is-child:active{border-bottom:1px solid transparent;border-top:1px solid transparent}.xpo-ShellNavigationGroup .xpo-ShellNavigationItem--is-child:before{display:none}.xpo-ShellNavigationGroup .xpo-ShellNavigationItem:hover,.xpo-ShellNavigationGroup .xpo-ShellNavigationItem--is-active{border-bottom:1px solid transparent;border-top:1px solid transparent}.xpo-ShellNavigationGroup--is-active,.xpo-ShellNavigationGroup:hover{border-bottom:1px solid #e6e6e6;border-top:1px solid #e6e6e6;background:#fcfcfc}.xpo-ShellNavigationGroup .xpo-ShellNavigationItem-children.xpo-ShellNavigationItem--is-active,.xpo-ShellNavigationGroup .xpo-ShellNavigationItem-children.xpo-ShellNavigationItem--is-active:active{border:none}.xpo-ShellNavigation{overflow-y:auto}.xpo-ShellNavigationItem{align-items:center;color:#6f6f6f;cursor:pointer;display:flex;height:48px;justify-content:space-between;max-width:256px;position:relative;transition:background-color ease-in-out .15s;-webkit-user-select:none;user-select:none;border-bottom:1px solid transparent;border-top:1px solid transparent}.xpo-ShellNavigationItem:hover,.xpo-ShellNavigationItem:focus{outline:none;text-decoration:none}.xpo-ShellNavigationItem:focus{background-color:#fcfcfc;color:#0d94f4}.xpo-ShellNavigationItem:hover{background-color:#fcfcfc;color:#6f6f6f;border-bottom:1px solid #e6e6e6;border-top:1px solid #e6e6e6}.xpo-ShellNavigationItem--is-active{background-color:#fcfcfc;border-bottom:1px solid #e6e6e6;border-top:1px solid #e6e6e6}.xpo-ShellNavigationItem--is-active:active{border-bottom:1px solid transparent;border-top:1px solid transparent}.xpo-ShellNavigationItem--is-active:before{background-color:#0d94f4;content:\"\";display:block;height:48px;position:absolute;width:4px}.xpo-ShellNavigationItem--is-child .xpo-ShellNavigationItem-groupIndicator{margin-left:20px}.xpo-ShellNavigationItem--is-child .xpo-ShellNavigationItem-title:hover{color:#0868ac}.xpo-ShellNavigationItem--is-child .xpo-ShellNavigationItem-title:active{color:#0d94f4}.xpo-ShellNavigationItem--is-child.xpo-ShellNavigationItem--is-active .xpo-ShellNavigationItem-title{color:#0d94f4}.xpo-ShellNavigationItem-title{color:#6f6f6f;flex-basis:100%;font-weight:500}.xpo-ShellNavigationItem-groupIndicator{transform:rotate(0);transition:transform .15s ease-in-out}.xpo-ShellNavigationItem-groupIndicator--is-open{transform:rotate(90deg)}.xpo-ShellNavigationItem-externalIndicator:hover{color:#0868ac}.xpo-ShellNavigationItem-groupIndicator,.xpo-ShellNavigationItem-externalIndicator{display:block;flex-shrink:0;height:24px;margin-left:8px;margin-right:8px;width:24px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoShellNavigation, [{
        type: Component,
        args: [{
                selector: '[xpo-shell-navigation]',
                templateUrl: './shell-navigation.component.html',
                styleUrls: ['./shell-navigation.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-ShellNavigation' },
            }]
    }], null, null); })();

const _c0$2 = ["xpo-shell-navigation-item", ""];
function XpoShellNavigationItem_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "chevron_right");
    i0.ɵɵelementEnd();
} }
function XpoShellNavigationItem_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵlistener("click", function XpoShellNavigationItem_span_5_Template_span_click_0_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.handleClick($event); });
    i0.ɵɵelementStart(1, "mat-icon", 5);
    i0.ɵɵtext(2, "launch");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c1$1 = ["*"];
class XpoShellNavigationItem {
    constructor(location) {
        this.location = location;
        /** The Observable for tab state changes */
        this.activeChangeSource = new BehaviorSubject(false);
        /** The URL of the link */
        this.url = null;
    }
    /** Whether or not the link should open in a new tab */
    get external() {
        return this.externalValue;
    }
    set external(value) {
        this.externalValue = coerceBooleanProperty(value);
    }
    /** Whether or not the link should open in a new window */
    get openInNewWindow() {
        return this.openInNewWindowValue;
    }
    set openInNewWindow(value) {
        this.openInNewWindowValue = coerceBooleanProperty(value);
    }
    /** Whether or not it is a group header */
    get isGroupHeader() {
        return this.isGroupHeaderValue;
    }
    set isGroupHeader(value) {
        this.isGroupHeaderValue = coerceBooleanProperty(value);
    }
    /** Whether or not the child links of a group are shown */
    get showChildLinks() {
        return this.showChildLinksValue;
    }
    set showChildLinks(value) {
        this.showChildLinksValue = coerceBooleanProperty(value);
    }
    /** Whether or not the tab is active */
    get isActive() {
        return this.isActiveValue;
    }
    set isActive(value) {
        if (value !== this.isActiveValue) {
            this.isActiveValue = coerceBooleanProperty(value);
            this.activeChangeSource.next(value);
        }
    }
    /** The title of the link
     *
     * @deprecated use content projection instead: `<a xpo-shell-navigation-item>{{ title }}</a>`
     */
    get title() {
        return this.titleValue;
    }
    set title(v) {
        this.titleValue = v;
        console.warn('WARN: Using the [title] input for xpo-shell-navigation-item is deprecated, ' +
            'use content projection instead: <a xpo-shell-navigation-item>{{ title }}</a>');
    }
    /** The active change observable */
    get activeChange$() {
        return this.activeChangeSource.asObservable();
    }
    /** Handles the link click to open up a new browser tab or window */
    handleClick(event) {
        if (this.external) {
            event.preventDefault(); // Stops native navigation
            event.stopPropagation(); // Stops Angular Router Navigation
            let features = null;
            if (this.openInNewWindow) {
                // Adding a feature to the "window.open()" function will force a new window instead of just a new tab.
                features = 'scrollbars=no';
            }
            window.open(this.location.prepareExternalUrl(this.url || '/'), '_blank', features);
        }
    }
}
XpoShellNavigationItem.ɵfac = function XpoShellNavigationItem_Factory(t) { return new (t || XpoShellNavigationItem)(i0.ɵɵdirectiveInject(i1.Location)); };
XpoShellNavigationItem.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoShellNavigationItem, selectors: [["a", "xpo-shell-navigation-item", ""]], hostAttrs: [1, "xpo-ShellNavigationItem"], hostVars: 2, hostBindings: function XpoShellNavigationItem_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("xpo-ShellNavigationItem--is-active", ctx.isActive);
    } }, inputs: { external: "external", openInNewWindow: "openInNewWindow", isGroupHeader: "isGroupHeader", showChildLinks: "showChildLinks", isActive: "isActive", title: "title", url: "url" }, attrs: _c0$2, ngContentSelectors: _c1$1, decls: 6, vars: 5, consts: [[1, "xpo-ShellNavigationItem-groupIndicator"], [4, "ngIf"], [1, "xpo-ShellNavigationItem-title"], ["class", "xpo-ShellNavigationItem-externalIndicator", 3, "click", 4, "ngIf"], [1, "xpo-ShellNavigationItem-externalIndicator", 3, "click"], ["inline", ""]], template: function XpoShellNavigationItem_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "span", 0);
        i0.ɵɵtemplate(1, XpoShellNavigationItem_mat_icon_1_Template, 2, 0, "mat-icon", 1);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵprojection(4);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, XpoShellNavigationItem_span_5_Template, 3, 0, "span", 3);
    } if (rf & 2) {
        i0.ɵɵclassProp("xpo-ShellNavigationItem-groupIndicator--is-open", ctx.showChildLinks);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isGroupHeader);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.title, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.external);
    } }, directives: [i1.NgIf, i2.MatIcon], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoShellNavigationItem, [{
        type: Component,
        args: [{
                selector: 'a[xpo-shell-navigation-item]',
                templateUrl: './shell-navigation-item.component.html',
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    class: 'xpo-ShellNavigationItem',
                    '[class.xpo-ShellNavigationItem--is-active]': 'isActive',
                },
                encapsulation: ViewEncapsulation.None,
            }]
    }], function () { return [{ type: i1.Location }]; }, { external: [{
            type: Input
        }], openInNewWindow: [{
            type: Input
        }], isGroupHeader: [{
            type: Input
        }], showChildLinks: [{
            type: Input
        }], isActive: [{
            type: Input
        }], title: [{
            type: Input
        }], url: [{
            type: Input
        }] }); })();

function XpoShellNavigationGroup_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("xpo-ShellNavigationItem--is-active", ctx_r0.showChildLinks && ctx_r0.childLinkActive);
} }
const _c0$1 = ["*"];
class XpoShellNavigationGroup {
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        /** Whether or not a child link is active */
        this.showChildLinks = false;
        /** Whether or not a child link is active */
        this.childLinkActive = false;
        /** The tracker for the group's subscriptions */
        this.destroyed$ = new Subject();
    }
    /** Show the "active" bar if a child is active while this is closed */
    get childActiveWhileGroupClosed() {
        return !this.showChildLinks && this.childLinkActive;
    }
    ngAfterContentInit() {
        // Check if any child link is active to initialize group active state
        this.childLinkActive = this.links.some((l) => l.isActive);
        if (this.childLinkActive) {
            this.openSubLinkView();
        }
        // Subscribe to changes in child links active state to update group active state
        // TODO: Maybe subscribe to the content children's changes event to resubscribe if new links appear
        combineLatest([...this.links.map((link) => link.activeChange$)])
            .pipe(debounceTime(100), takeUntil(this.destroyed$))
            .subscribe((isActiveCollection) => {
            this.childLinkActive = isActiveCollection.some((v) => !!v);
            if (this.childLinkActive) {
                this.openSubLinkView();
            }
            this.changeDetectorRef.markForCheck();
        });
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    /** Toggles the child links */
    toggleChildLinks() {
        if (!this.showChildLinks) {
            this.openSubLinkView();
        }
        else {
            this.closeSubLinkView();
        }
    }
    /** Opens the child links */
    openSubLinkView() {
        this.showChildLinks = true;
    }
    /** Closes the child links */
    closeSubLinkView() {
        this.showChildLinks = false;
    }
}
XpoShellNavigationGroup.ɵfac = function XpoShellNavigationGroup_Factory(t) { return new (t || XpoShellNavigationGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
XpoShellNavigationGroup.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoShellNavigationGroup, selectors: [["xpo-shell-navigation-group"]], contentQueries: function XpoShellNavigationGroup_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, XpoShellNavigationItem, 4);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.links = _t);
    } }, hostAttrs: [1, "xpo-ShellNavigationGroup"], hostVars: 2, hostBindings: function XpoShellNavigationGroup_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("xpo-ShellNavigationGroup--is-active", ctx.childLinkActive);
    } }, inputs: { title: "title" }, ngContentSelectors: _c0$1, decls: 3, vars: 4, consts: [["xpo-shell-navigation-item", "", "routerLinkActive", "", "isGroupHeader", "", 3, "isActive", "showChildLinks", "click"], ["class", "xpo-ShellNavigationItem-children", 3, "xpo-ShellNavigationItem--is-active", 4, "ngIf"], [1, "xpo-ShellNavigationItem-children"]], template: function XpoShellNavigationGroup_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "a", 0);
        i0.ɵɵlistener("click", function XpoShellNavigationGroup_Template_a_click_0_listener() { return ctx.toggleChildLinks(); });
        i0.ɵɵtext(1);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(2, XpoShellNavigationGroup_div_2_Template, 2, 2, "div", 1);
    } if (rf & 2) {
        i0.ɵɵproperty("isActive", ctx.childActiveWhileGroupClosed || ctx.childLinkActive)("showChildLinks", ctx.showChildLinks);
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.title, "\n");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showChildLinks);
    } }, directives: [XpoShellNavigationItem, i2$1.RouterLinkActive, i1.NgIf], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoShellNavigationGroup, [{
        type: Component,
        args: [{
                selector: 'xpo-shell-navigation-group',
                templateUrl: './shell-navigation-group.component.html',
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                host: {
                    class: 'xpo-ShellNavigationGroup',
                    '[class.xpo-ShellNavigationGroup--is-active]': 'childLinkActive',
                },
            }]
    }], function () { return [{ type: i0.ChangeDetectorRef }]; }, { title: [{
            type: Input
        }], links: [{
            type: ContentChildren,
            args: [XpoShellNavigationItem]
        }] }); })();

function XpoShell_xpo_header_hamburger_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "xpo-header-hamburger", 10);
    i0.ɵɵlistener("click", function XpoShell_xpo_header_hamburger_1_Template_xpo_header_hamburger_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.onMenuClick(); });
    i0.ɵɵelementEnd();
} }
function XpoShell_ng_container_14_ng_container_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15, 16);
    i0.ɵɵlistener("click", function XpoShell_ng_container_14_ng_container_1_a_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(3); return ctx_r13.handleLinkClick(); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const childLink_r11 = ctx.$implicit;
    const _r12 = i0.ɵɵreference(1);
    i0.ɵɵproperty("url", childLink_r11.path)("queryParamsHandling", childLink_r11.queryParamsHandling || "")("isActive", _r12.isActive)("external", childLink_r11.openInNewTab)("routerLink", childLink_r11.path);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", childLink_r11.label, " ");
} }
function XpoShell_ng_container_14_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "xpo-shell-navigation-group", 13);
    i0.ɵɵtemplate(2, XpoShell_ng_container_14_ng_container_1_a_2_Template, 3, 6, "a", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const routerLink_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("title", routerLink_r6.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", routerLink_r6.children);
} }
function XpoShell_ng_container_14_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 17, 16);
    i0.ɵɵlistener("click", function XpoShell_ng_container_14_ng_template_2_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.handleLinkClick(); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r16 = i0.ɵɵreference(1);
    const routerLink_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("url", routerLink_r6.path)("queryParamsHandling", routerLink_r6.queryParamsHandling || "")("isActive", _r16.isActive)("external", routerLink_r6.openInNewTab)("routerLink", routerLink_r6.path);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", routerLink_r6.label, " ");
} }
function XpoShell_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, XpoShell_ng_container_14_ng_container_1_Template, 3, 2, "ng-container", 11);
    i0.ɵɵtemplate(2, XpoShell_ng_container_14_ng_template_2_Template, 3, 6, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const routerLink_r6 = ctx.$implicit;
    const _r8 = i0.ɵɵreference(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", routerLink_r6.children)("ngIfElse", _r8);
} }
function XpoShell_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("v", ctx_r3.versionNumber, "");
} }
const _c0 = [[["xpo-app-switcher-popover"]], [["xpo-application-switcher"]], [["xpo-header-app-name"]], [["xpo-header-sub-app-name"]], [["xpo-header-items"]], [["xpo-header-navigation"]], [["xpo-header-actions"]], [["xpo-header-utilities-actions"]], [["xpo-shell-sidebar-actions"]], "*"];
const _c1 = ["xpo-app-switcher-popover", "xpo-application-switcher", "xpo-header-app-name", "xpo-header-sub-app-name", "xpo-header-items", "xpo-header-navigation", "xpo-header-actions", "xpo-header-utilities-actions", "xpo-shell-sidebar-actions", "*"];
class XpoShellSidebarActions {
}
XpoShellSidebarActions.ɵfac = function XpoShellSidebarActions_Factory(t) { return new (t || XpoShellSidebarActions)(); };
XpoShellSidebarActions.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: XpoShellSidebarActions, selectors: [["xpo-shell-sidebar-actions"]], hostAttrs: [1, "xpo-Shell-sidebar-actions"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoShellSidebarActions, [{
        type: Directive,
        args: [{
                selector: 'xpo-shell-sidebar-actions',
                host: { class: 'xpo-Shell-sidebar-actions' },
            }]
    }], null, null); })();
class XpoShell {
    constructor(breakpointObserver, changeDetectionRef, router) {
        this.breakpointObserver = breakpointObserver;
        this.changeDetectionRef = changeDetectionRef;
        this.router = router;
        /** Whether or not we're in tablet mode or not */
        this.isTablet = false;
        /** Observable Cleanup */
        this.destroyed$ = new Subject();
        this.routesValue = [];
        this.drawerClosedByDefaultValue = false;
        this.isDrawerOpenValue = true;
        this.isDrawerOpenChange = new EventEmitter();
        /** The width of the logo. Defaults to 126px */
        this.logoWidth = '126px';
    }
    /** The routes for the application */
    get routes() {
        return this.routesValue;
    }
    set routes(value) {
        this.routesValue = value;
        // When routes are received, open drawer if the its not set to drawerClosedByDefault
        if (!this.drawerClosedByDefault) {
            this.isDrawerOpen = !this.isTablet && this.hasRoutes;
        }
    }
    /** Whether or not the sidebar should be closed by default */
    get drawerClosedByDefault() {
        return this.drawerClosedByDefaultValue;
    }
    set drawerClosedByDefault(value) {
        this.drawerClosedByDefaultValue = coerceBooleanProperty(value);
        if (this.drawerClosedByDefaultValue) {
            this.isDrawerOpen = false;
        }
    }
    /** The version number of the application */
    get versionNumber() {
        return this.versionNumberValue;
    }
    set versionNumber(value) {
        this.versionNumberValue = value;
    }
    /** Whether or not the drawer is open */
    get isDrawerOpen() {
        return this.isDrawerOpenValue;
    }
    set isDrawerOpen(value) {
        const v = coerceBooleanProperty(value);
        if (v !== this.isDrawerOpenValue) {
            this.isDrawerOpenValue = v;
            this.isDrawerOpenChange.emit(v);
        }
    }
    get hasRoutes() {
        return !!this.routes && !!this.routes.length;
    }
    /**
     * Returns the application name
     */
    get appName() {
        // get application name from application name child component
        return this.appNameComponent ? this.appNameComponent.appName : '';
    }
    /**
     * Returns the application sub-name
     */
    get appSubName() {
        // get application sub-name from application name child component
        return this.appSubNameComponent ? this.appSubNameComponent.appSubName : '';
    }
    ngOnInit() {
        this.subscribeToBreakpointChanges();
        this.subscribeToNavigationEndChanges();
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    /** When a link is clicked when in tablet mode, close the drawer */
    handleLinkClick() {
        if (this.isTablet) {
            this.isDrawerOpen = false;
        }
    }
    /** Open the drawer if the drawer is closed and if there is routes available */
    onMenuClick() {
        this.isDrawerOpen = this.hasRoutes && !this.isDrawerOpen;
    }
    subscribeToBreakpointChanges() {
        // If viewport is less than a tablet, hide the drawer on default
        this.breakpointObserver
            .observe('(max-width: 1024px)') // FIXME: width width width
            .pipe(takeUntil(this.destroyed$))
            .subscribe((result) => {
            this.isTablet = result.matches;
            /**
             * Open drawer when the view is not the size of a tablet, there is
             * routes available, and if the shell is not set to have the
             * menu closed on default
             */
            this.isDrawerOpen = !this.isTablet && this.hasRoutes && !this.drawerClosedByDefault;
            this.changeDetectionRef.markForCheck();
        });
    }
    /**
     * Since some routes are lazy loaded, `routerLinkActive` does
     * not get updated to make the link look active, Need to manually
     * trigger change detection when a navigation end event triggers.
     * https://github.com/angular/angular/issues/19934
     */
    subscribeToNavigationEndChanges() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd), takeUntil(this.destroyed$))
            .subscribe(() => this.changeDetectionRef.markForCheck());
    }
}
XpoShell.ɵfac = function XpoShell_Factory(t) { return new (t || XpoShell)(i0.ɵɵdirectiveInject(i1$1.BreakpointObserver), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2$1.Router)); };
XpoShell.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoShell, selectors: [["xpo-shell"]], contentQueries: function XpoShell_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, XpoHeaderAppName, 5);
        i0.ɵɵcontentQuery(dirIndex, XpoHeaderSubAppName, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.appNameComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.appSubNameComponent = _t.first);
    } }, hostAttrs: [1, "xpo-Shell"], inputs: { routes: "routes", drawerClosedByDefault: "drawerClosedByDefault", versionNumber: "versionNumber", isDrawerOpen: "isDrawerOpen", logoPath: "logoPath", logoWidth: "logoWidth" }, outputs: { isDrawerOpenChange: "isDrawerOpenChange" }, ngContentSelectors: _c1, decls: 21, vars: 6, consts: [["xpo-header", ""], [3, "click", 4, "ngIf"], [3, "showCollapseButton", "mode", "opened", "openedChange"], ["drawer", ""], [1, "xpo-Shell-sidebar"], ["xpo-shell-navigation", ""], [4, "ngFor", "ngForOf"], [1, "xpo-Shell-navFooter"], [1, "xpo-Shell-navFooter-poweredBy"], ["class", "xpo-Shell-navFooter-versionNumber", 4, "ngIf"], [3, "click"], [4, "ngIf", "ngIfElse"], ["singleLink", ""], [3, "title"], ["xpo-shell-navigation-item", "", "routerLinkActive", "", "class", "xpo-ShellNavigationItem--is-child", 3, "url", "queryParamsHandling", "isActive", "external", "routerLink", "click", 4, "ngFor", "ngForOf"], ["xpo-shell-navigation-item", "", "routerLinkActive", "", 1, "xpo-ShellNavigationItem--is-child", 3, "url", "queryParamsHandling", "isActive", "external", "routerLink", "click"], ["rla", "routerLinkActive"], ["xpo-shell-navigation-item", "", "routerLinkActive", "", 3, "url", "queryParamsHandling", "isActive", "external", "routerLink", "click"], [1, "xpo-Shell-navFooter-versionNumber"]], template: function XpoShell_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵprojectionDef(_c0);
        i0.ɵɵelementStart(0, "header", 0);
        i0.ɵɵtemplate(1, XpoShell_xpo_header_hamburger_1_Template, 1, 0, "xpo-header-hamburger", 1);
        i0.ɵɵprojection(2, 0, ["ngProjectAs", "xpo-app-switcher-popover", 5, ["xpo-app-switcher-popover"]]);
        i0.ɵɵprojection(3, 1, ["ngProjectAs", "xpo-application-switcher", 5, ["xpo-application-switcher"]]);
        i0.ɵɵprojection(4, 2, ["ngProjectAs", "xpo-header-app-name", 5, ["xpo-header-app-name"]]);
        i0.ɵɵprojection(5, 3, ["ngProjectAs", "xpo-header-sub-app-name", 5, ["xpo-header-sub-app-name"]]);
        i0.ɵɵprojection(6, 4, ["ngProjectAs", "xpo-header-items", 5, ["xpo-header-items"]]);
        i0.ɵɵprojection(7, 5, ["ngProjectAs", "xpo-header-navigation", 5, ["xpo-header-navigation"]]);
        i0.ɵɵprojection(8, 6, ["ngProjectAs", "xpo-header-actions", 5, ["xpo-header-actions"]]);
        i0.ɵɵprojection(9, 7, ["ngProjectAs", "xpo-header-utilities-actions", 5, ["xpo-header-utilities-actions"]]);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "xpo-tab-drawer", 2, 3);
        i0.ɵɵlistener("openedChange", function XpoShell_Template_xpo_tab_drawer_openedChange_10_listener($event) { return ctx.isDrawerOpen = $event; });
        i0.ɵɵelementStart(12, "div", 4);
        i0.ɵɵelementStart(13, "nav", 5);
        i0.ɵɵtemplate(14, XpoShell_ng_container_14_Template, 4, 2, "ng-container", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 7);
        i0.ɵɵelement(16, "div", 8);
        i0.ɵɵtemplate(17, XpoShell_div_17_Template, 3, 1, "div", 9);
        i0.ɵɵprojection(18, 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "xpo-tab-drawer-content");
        i0.ɵɵprojection(20, 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasRoutes);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("showCollapseButton", false)("mode", ctx.isTablet ? "over" : "side")("opened", ctx.isDrawerOpen);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.routes);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.versionNumber);
    } }, directives: [i3.XpoHeader, i1.NgIf, i5.XpoTabsDrawer, XpoShellNavigation, i1.NgForOf, i5.XpoTabDrawerContent, i3.XpoHeaderHamburger, XpoShellNavigationGroup, XpoShellNavigationItem, i2$1.RouterLinkWithHref, i2$1.RouterLinkActive], styles: [".flex--stretch{flex:1}.xpo-Shell{display:flex;flex-direction:column;height:100%}.xpo-Shell-sidebar{display:flex;flex-direction:column;height:100%}.xpo-Shell-sidebar-actions{display:flex;justify-content:center;padding-top:16px}.xpo-Shell-hamburger.mat-icon-button{padding-right:16px}.xpo-Shell-navFooter{background-color:#fff;border-top:1px solid #f3f3f3;display:block;margin-top:auto;padding:16px;width:100%}.xpo-Shell-navFooter-poweredBy:after{background:url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%22177%22 height%3D%2216%22%3E%3Cg fill%3D%22none%22 fill-rule%3D%22evenodd%22%3E%3Cpath fill%3D%22%236F6F6F%22 d%3D%22M1.468 9.104V13H.155V3.047h3.671c1.09 0 1.943.278 2.56.834.618.556.926 1.292.926 2.208 0 .966-.301 1.71-.905 2.232-.604.522-1.469.783-2.595.783H1.469zm0-1.074h2.358c.702 0 1.24-.165 1.613-.495.374-.33.561-.808.561-1.432 0-.593-.187-1.067-.56-1.422-.374-.356-.887-.54-1.539-.554H1.468V8.03zm6.986 1.203c0-.724.143-1.376.427-1.955a3.187 3.187 0 0 1 1.19-1.34c.508-.314 1.088-.471 1.74-.471 1.007 0 1.821.348 2.443 1.046.622.697.934 1.624.934 2.782v.089c0 .72-.138 1.366-.414 1.938a3.14 3.14 0 0 1-1.183 1.336c-.512.32-1.101.479-1.767.479-1.002 0-1.815-.349-2.437-1.046-.622-.697-.933-1.62-.933-2.769v-.089zm1.272.15c0 .821.19 1.48.57 1.976.38.497.89.745 1.528.745.643 0 1.153-.251 1.531-.755.379-.503.568-1.209.568-2.116 0-.81-.193-1.468-.578-1.972-.385-.503-.896-.755-1.534-.755-.625 0-1.128.248-1.511.745s-.574 1.208-.574 2.133zm13.596 1.874l1.422-5.653h1.265L23.855 13H22.83l-1.798-5.605L19.282 13h-1.025L16.11 5.604h1.258l1.456 5.537 1.723-5.537h1.018l1.757 5.653zm7.041 1.88c-1.002 0-1.818-.33-2.447-.988-.629-.659-.943-1.54-.943-2.642v-.233c0-.733.14-1.388.42-1.965a3.28 3.28 0 0 1 1.176-1.353 2.956 2.956 0 0 1 1.637-.49c.962 0 1.709.318 2.242.951.533.633.8 1.54.8 2.72v.527h-5.01c.018.73.23 1.318.638 1.767.408.449.927.673 1.556.673.446 0 .825-.09 1.134-.273.31-.182.581-.424.814-.725l.772.602c-.62.952-1.55 1.429-2.789 1.429zm-.157-6.631c-.51 0-.939.186-1.285.557-.346.371-.56.892-.643 1.562h3.705v-.096c-.036-.642-.21-1.14-.52-1.493-.309-.354-.728-.53-1.257-.53zm8.08.232a3.79 3.79 0 0 0-.622-.048c-.83 0-1.392.354-1.688 1.06V13H34.71V5.604h1.23l.02.854c.416-.66 1.004-.991 1.765-.991.246 0 .433.032.56.096v1.175zm4.232 6.399c-1.003 0-1.819-.33-2.448-.988-.629-.659-.943-1.54-.943-2.642v-.233c0-.733.14-1.388.42-1.965a3.28 3.28 0 0 1 1.176-1.353 2.956 2.956 0 0 1 1.637-.49c.962 0 1.71.318 2.243.951.533.633.8 1.54.8 2.72v.527h-5.011c.018.73.23 1.318.639 1.767.408.449.926.673 1.555.673.447 0 .825-.09 1.135-.273.31-.182.58-.424.813-.725l.773.602c-.62.952-1.55 1.429-2.79 1.429zm-.158-6.631c-.51 0-.938.186-1.285.557-.346.371-.56.892-.642 1.562h3.705v-.096c-.037-.642-.21-1.14-.52-1.493-.31-.354-.729-.53-1.258-.53zm4.198 2.734c0-1.135.268-2.047.806-2.738.538-.69 1.242-1.035 2.113-1.035.865 0 1.551.296 2.057.888V2.5H52.8V13h-1.162l-.062-.793c-.506.62-1.21.93-2.112.93-.857 0-1.555-.351-2.095-1.053-.54-.702-.81-1.618-.81-2.748V9.24zm1.264.144c0 .838.173 1.495.52 1.969.346.473.825.71 1.435.71.802 0 1.388-.36 1.757-1.08V7.586c-.378-.697-.96-1.046-1.743-1.046-.62 0-1.103.24-1.45.718-.346.478-.519 1.187-.519 2.126zm16.666 0c0 1.13-.26 2.038-.779 2.724-.52.686-1.217 1.029-2.092 1.029-.934 0-1.656-.33-2.167-.991L59.39 13h-1.162V2.5h1.264v3.917c.51-.633 1.215-.95 2.113-.95.897 0 1.603.34 2.115 1.018.513.68.77 1.61.77 2.79v.109zm-1.264-.144c0-.861-.167-1.526-.5-1.996-.332-.47-.81-.704-1.435-.704-.834 0-1.433.387-1.798 1.162v3.2c.388.774.991 1.161 1.812 1.161.606 0 1.078-.234 1.415-.704.337-.469.506-1.175.506-2.119zm5.277 1.907l1.723-5.543h1.353l-2.973 8.538c-.46 1.23-1.192 1.845-2.195 1.845l-.24-.02-.47-.09v-1.024l.341.027c.428 0 .762-.087 1.002-.26.239-.173.436-.49.59-.95l.281-.752-2.639-7.314h1.381l1.846 5.543z%22%2F%3E%3Cpath fill%3D%22%2308120D%22 d%3D%22M119.794 12.9H111.2V1.02h3.633v8.776h4.961V12.9%22%2F%3E%3Cpath fill%3D%22%2308120D%22 d%3D%22M122.886 8.62c0 1.444.437 2.223 1.35 2.223.932 0 1.467-.731 1.467-2.23 0-1.427-.552-2.2-1.5-2.2-.897 0-1.317.761-1.317 2.206zm5.938-.037c0 2.712-1.897 4.585-4.587 4.585-2.708 0-4.57-1.855-4.57-4.549 0-2.694 1.88-4.567 4.604-4.567 2.69 0 4.553 1.838 4.553 4.531z%22%2F%3E%3Cpath fill%3D%22%2308120D%22 d%3D%22M131.948 8.41c0 1.195.436 1.831 1.402 1.831.897 0 1.385-.624 1.385-1.694 0-1.142-.488-2.08-1.385-2.08s-1.402.89-1.402 1.943zm5.823 3.385c0 1.105-.139 1.712-.535 2.337-.707 1.141-1.885 1.659-3.851 1.659-3.155 0-4.014-.724-4.277-2.896h2.995c.173.739.35 1.094 1.299 1.094.96 0 1.27-.432 1.27-1.63v-.934c-.638.767-1.27 1.07-2.304 1.07-2.225 0-3.553-1.516-3.553-4.067 0-2.515 1.397-4.394 3.553-4.394 1.103 0 1.683.357 2.27 1.285V4.284h3.133v7.51zM138.471 12.9h3.248V4.284h-3.248zM155.695 6.762h-2.3v2.642c.028 1.035.155 1.178 1.224 1.178h1.075V12.9a29.12 29.12 0 0 1-2.282.108c-1.621 0-2.524-.34-2.972-1.195-.241-.464-.31-.785-.31-1.767l-.018-5.762 3.283-3.273v3.273h2.3v2.478M156.41 12.9h3.248V4.284h-3.248z%22%2F%3E%3Cpath fill%3D%22%2308120D%22 d%3D%22M164.212 13.115c-2.703 0-4.552-1.784-4.552-4.442 0-2.748 1.832-4.585 4.587-4.585 2.4 0 4.124 1.406 4.262 3.476h-3.08c-.087-.696-.524-1.169-1.165-1.169-.918 0-1.392.815-1.392 2.296 0 1.32.457 2.063 1.375 2.063.497 0 1.112-.132 1.25-1.006h3.08c-.292 2.32-1.913 3.367-4.365 3.367m9.632-6.353c-.12-.606-.35-.795-1.075-.795-.603 0-.868.208-.868.565 0 .41.178.517 1.816.82 1.794.34 2.673.803 3.036 1.588.154.357.24.75.24 1.16 0 1.909-1.551 3.015-4.19 3.015-3.096 0-4.07-1.268-4.225-3.367h3.047c.07.744.114 1.345 1.213 1.345.578 0 1.006-.267 1.006-.696 0-.367-.075-.53-1.61-.868-1.466-.321-1.914-.464-2.431-.785-.673-.41-1.052-1.124-1.052-1.98 0-1.749 1.397-2.73 3.932-2.73 2.672 0 3.914.82 4.086 2.728h-2.925m-26.863 0c-.12-.576-.35-.795-1.075-.795-.603 0-.868.208-.868.565 0 .41.178.517 1.816.82 1.794.34 2.673.803 3.036 1.588.155.357.24.75.24 1.16 0 1.909-1.551 3.015-4.19 3.015-3.096 0-4.07-1.298-4.225-3.367h3.047c.069.714.114 1.345 1.213 1.345.579 0 1.006-.267 1.006-.696 0-.367-.075-.53-1.61-.868-1.465-.321-1.914-.464-2.431-.785-.673-.41-1.052-1.124-1.052-1.98 0-1.749 1.397-2.73 3.932-2.73 2.673 0 3.914.85 4.087 2.728h-2.926%22%2F%3E%3Cpath fill%3D%22%23C00%22 d%3D%22M84.827 6.603l4.127 6.297H84.69l-1.121-1.926c-.397-.678-.586-1.053-.845-1.712a16.194 16.194 0 0 1-.914 1.766l-.96 1.872h-4.213l4.173-6.297L76.63 1.02h4.119s1.87 2.711 2.128 3.317c.19-.446 1.896-3.317 1.896-3.317h4.18l-4.127 5.583m7.766-.16h1.408c1.018.018 1.449-.375 1.449-1.231 0-.857-.483-1.267-1.518-1.267h-1.339v2.498zm1.19-5.423c1.88 0 2.742.178 3.535.73 1.07.732 1.673 1.981 1.673 3.48 0 1.16-.397 2.158-1.139 2.925-.741.75-1.69 1.089-3.207 1.089h-2.052V12.9h-3.639V1.02h4.829z%22%2F%3E%3Cpath fill%3D%22%23C00%22 d%3D%22M102.552 6.907c0 2.122.741 3.354 2.207 3.354 1.431 0 2.121-1.196 2.121-3.444 0-1.998-.741-3.175-2.138-3.175-1.414 0-2.19 1.249-2.19 3.265zm7.984.071c0 3.729-2.328 6.208-5.777 6.208-3.518 0-5.88-2.462-5.88-6.226s2.345-6.244 5.915-6.244c3.431 0 5.742 2.533 5.742 6.262z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\") no-repeat center;content:\"\";display:block;height:15px;width:100%}.xpo-Shell-navFooter-versionNumber{color:#9b9b9b;font-size:.875rem;height:1rem;text-align:center}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoShell, [{
        type: Component,
        args: [{
                selector: 'xpo-shell',
                templateUrl: './shell.component.html',
                styleUrls: ['./shell.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
                host: { class: 'xpo-Shell' }
            }]
    }], function () { return [{ type: i1$1.BreakpointObserver }, { type: i0.ChangeDetectorRef }, { type: i2$1.Router }]; }, { routes: [{
            type: Input
        }], drawerClosedByDefault: [{
            type: Input
        }], versionNumber: [{
            type: Input
        }], isDrawerOpen: [{
            type: Input
        }], isDrawerOpenChange: [{
            type: Output
        }], logoPath: [{
            type: Input
        }], logoWidth: [{
            type: Input
        }], appNameComponent: [{
            type: ContentChild,
            args: [XpoHeaderAppName]
        }], appSubNameComponent: [{
            type: ContentChild,
            args: [XpoHeaderSubAppName]
        }] }); })();

class XpoShellModule {
}
XpoShellModule.ɵfac = function XpoShellModule_Factory(t) { return new (t || XpoShellModule)(); };
XpoShellModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoShellModule });
XpoShellModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [], imports: [[
            CommonModule,
            MatIconModule,
            MatButtonModule,
            MatBadgeModule,
            RouterModule.forChild([]),
            XpoHeaderModule,
            XpoTabDrawerModule,
            XpoAppSwitcherPopoverModule,
            XpoAccountPopoverModule,
            XpoNotificationPopoverModule,
        ], XpoHeaderModule,
        XpoAppSwitcherPopoverModule,
        XpoAccountPopoverModule,
        XpoNotificationPopoverModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoShellModule, [{
        type: NgModule,
        args: [{
                declarations: [XpoShell, XpoShellSidebarActions, XpoShellNavigationItem, XpoShellNavigationGroup, XpoShellNavigation],
                imports: [
                    CommonModule,
                    MatIconModule,
                    MatButtonModule,
                    MatBadgeModule,
                    RouterModule.forChild([]),
                    XpoHeaderModule,
                    XpoTabDrawerModule,
                    XpoAppSwitcherPopoverModule,
                    XpoAccountPopoverModule,
                    XpoNotificationPopoverModule,
                ],
                exports: [
                    XpoShell,
                    XpoHeaderModule,
                    XpoShellSidebarActions,
                    XpoAppSwitcherPopoverModule,
                    XpoAccountPopoverModule,
                    XpoNotificationPopoverModule,
                    XpoShellNavigationItem,
                    XpoShellNavigationGroup,
                    XpoShellNavigation,
                ],
                providers: [],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoShellModule, { declarations: [XpoShell, XpoShellSidebarActions, XpoShellNavigationItem, XpoShellNavigationGroup, XpoShellNavigation], imports: [CommonModule,
        MatIconModule,
        MatButtonModule,
        MatBadgeModule, i2$1.RouterModule, XpoHeaderModule,
        XpoTabDrawerModule,
        XpoAppSwitcherPopoverModule,
        XpoAccountPopoverModule,
        XpoNotificationPopoverModule], exports: [XpoShell,
        XpoHeaderModule,
        XpoShellSidebarActions,
        XpoAppSwitcherPopoverModule,
        XpoAccountPopoverModule,
        XpoNotificationPopoverModule,
        XpoShellNavigationItem,
        XpoShellNavigationGroup,
        XpoShellNavigation] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoShell, XpoShellModule, XpoShellNavigation, XpoShellNavigationGroup, XpoShellNavigationItem, XpoShellSidebarActions };
